// This file was automatically generated from appchart.dialog.reports.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.reports');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.reports.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="report-feed-dialog"><div class="el8OverflowHidden el8Tab report-tab-section" data-dd-privacy="allow"></div><div class="el8OverflowAuto report-feed-section"><div class="padv5"><div style=\'display: inline-block; width: 48%; padding-left: 10px;\'><a class="enter-poc-result-trigger el8StandardFontSize mr5 el8Hidden">Enter Point-of-Care Lab Result</a></div><div style=\'display: inline-block; width: 49%; text-align: right;\'>', (el8Globals.FEATURES.BiDiLabs) ? '<a class="show-outstanding-toggle-trigger el8StandardFontSize mr10">Showing: All</a>' : '', '<a class="refresh el8StandardFontSize">Refresh</a></div></div><div class="list-of-report-feeds"></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.reports.reportFeedContainer = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="type-', soy.$$escapeHtml(opt_data.reportTypeId), '-report-feed report-feed el8DialogFeedWrap"></div>');
  if (!opt_sb) return output.toString();
};
